/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {OnboardRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {OnboardResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const onboard = (request: OnboardRequest, options?: CashRequestOptions) => post<OnboardRequest, OnboardResponse>("/2.0/cash/onboard", request, {...options, rejectOnError: true })